// extracted by mini-css-extract-plugin
module.exports = {"Container":"TestimonialsSection_Container__2PJl-","Layout":"TestimonialsSection_Layout__2-E2o","Buttons":"TestimonialsSection_Buttons__3Roi1"};